export default "__VITE_ASSET__c72cc11a__"